import { isTauri } from './index';

/**
 * `fetch` for requests to the flight-data sources.
 *
 * In a browser this is the platform's own. In the desktop app it is Tauri's
 * HTTP plugin, which makes the request from the native side: the three
 * sources send no CORS header (`lib/sources/relay.ts` has the whole story),
 * and a request made outside the webview has no origin to refuse. So the
 * desktop app reaches every source directly, with no relay to configure. The
 * hosts it may reach are listed in `src-tauri/capabilities/default.json`.
 */
export const sourceFetch: typeof globalThis.fetch = async (input, init) => {
  if (isTauri()) {
    const { fetch } = await import('@tauri-apps/plugin-http');
    return fetch(input, init);
  }
  return globalThis.fetch(input, init);
};
